import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { isValidPassword, PASSWORD_RULES_MESSAGE } from '../utils/passwordPolicy';
import { useAuth } from '../context/AuthContext';
import GoogleLoginButton from '../components/GoogleLoginButton';

export default function Register() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();

  async function handleGoogleCredential(credential) {
    setError('');
    try {
      const user = await loginWithGoogle(credential);
      navigate(user.isAdmin ? '/admin' : '/usuarios', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao cadastrar com Google.');
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!isValidPassword(password)) {
      setError(PASSWORD_RULES_MESSAGE);
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/register', { nome, email, password, passwordConfirm });
      setSuccess('Cadastro realizado! Redirecionando para o login...');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao tentar cadastrar.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="page-container form-page">
      <h2>Cadastrar</h2>
      <form onSubmit={handleSubmit} className="form-card">
        {error && <div className="alert-error">{error}</div>}
        {success && <div className="alert-success">{success}</div>}
        <label>
          Nome
          <input
            type="text"
            value={nome}
            onChange={e => setNome(e.target.value)}
            required
            autoComplete="name"
          />
        </label>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </label>
        <label>
          Senha
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
          <small style={{ color: '#888', fontSize: '0.8rem' }}>{PASSWORD_RULES_MESSAGE}</small>
        </label>
        <label>
          Confirmar senha
          <input
            type="password"
            value={passwordConfirm}
            onChange={e => setPasswordConfirm(e.target.value)}
            required
            autoComplete="new-password"
          />
        </label>
        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Cadastrando...' : 'Cadastrar'}
        </button>
        <div style={{ textAlign: 'center', fontSize: '0.85rem', color: '#888' }}>ou</div>
        <GoogleLoginButton onCredential={handleGoogleCredential} text="signup_with" />
        <p style={{ textAlign: 'center', fontSize: '0.9rem', margin: 0 }}>
          Já tem conta? <Link to="/login">Faça login</Link>
        </p>
      </form>
    </main>
  );
}
